import styled from "@yb/styled-px2rem";
import {Swiper, SwiperSlide} from "swiper/react";
import {Ellipsis} from "@FRAMEWORK/ui/mobile/text";

const Wrap = styled.div`
	width: 100%;
	padding: 30px 0;
`;

const SubTitle = styled.h3`
	padding: 0 15px;
	font-size: 18px;
	color: var(--emp-color);
	font-weight: bold;
`;

const SliderWrap = styled.div`
	position: relative;
	margin-top: 15px;
	margin-bottom: 38px;
	.swiper-slide {
		width: 250px;
	}
`;

const Slider = styled(Swiper)`
	width: 100%;
	padding: 0 15px;

	.swiper-slide:not(:last-child) {
		margin-right: 15px;
	}
`;
const SwiperSlideWrap = styled(SwiperSlide)`
	overflow: hidden;
	a {
		display: block;
	}
`;
const ImageBox = styled.div`
	position: relative;
	height: 167px;
	margin-bottom: 11px;

	img {
		width: 100%;
		height: 167px;
		vertical-align: top;
	}
`;
const InfoBox = styled.div`
	color: var(--default-color);
`;
const SlideTitle = styled.div`
	min-height: 48px;
	margin-bottom: 8px;
	font-weight: bold;
	font-size: 17px;
	color: var(--emp-color);
	line-height: 1.41;
	${Ellipsis(2)};
`;
const Date = styled.div`
	font-size: 15px;
	color: var(--default-color);
	line-height: 1;
`;
const InfoBottomBlock = styled.div`
	display: flex;
	margin-top: 14px;
	font-size: 15px;
	line-height: 1;
	align-items: flex-end;
	justify-content: space-between;
`;
const Price = styled.div`
	margin-left: auto;
	color: var(--red-color);

	strong {
		font-size: 18px;
	}
`;

export {
	Date,
	ImageBox,
	InfoBottomBlock,
	InfoBox,
	Price,
	SlideTitle,
	Slider,
	SliderWrap,
	SubTitle,
	SwiperSlideWrap,
	Wrap,
};
